/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getFragmentFromSelection
 * 
 */

'use strict';

var getContentStateFragment = require('./getContentStateFragment');

function getFragmentFromSelection(editorState) {
  var selectionState = editorState.getSelection();
  if (!selectionState.isCollapsed()) {
    return getContentStateFragment(editorState.getCurrentContent(), selectionState);
  }
}

module.exports = getFragmentFromSelection;


/*****************
 ** WEBPACK FOOTER
 ** ./~/draft-js/lib/getFragmentFromSelection.js
 ** module id = 495
 ** module chunks = 0 2
 **/